import { twMerge } from 'tailwind-merge';
import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';

interface IProps {
  className?: string;
  isLinked?: boolean;
}

export const MapboxAttribution = ({ className, isLinked = true }: IProps) => {
  return (
    <span
      data-nosnippet
      className={twMerge(`absolute bottom-0 right-0 p-1 text-xs text-lake-fog`, className)}
    >
      {isLinked ? (
        <ExternalLink
          className="text-lake-fog"
          target="_blank"
          href="https://www.mapbox.com/about/maps/"
        >
          © Mapbox
        </ExternalLink>
      ) : (
        '© Mapbox'
      )}{' '}
      {isLinked ? (
        <ExternalLink
          className="text-lake-fog"
          target="_blank"
          href="http://www.openstreetmap.org/copyright"
        >
          © OpenStreetMap
        </ExternalLink>
      ) : (
        '© OpenStreetMap'
      )}{' '}
      {isLinked && (
        <strong>
          <ExternalLink
            href="https://labs.mapbox.com/contribute/"
            className="text-lake-fog"
            target="_blank"
          >
            Improve this map
          </ExternalLink>
        </strong>
      )}
    </span>
  );
};
